export const PRIMARY_FONT = `'Noto Serif Display', serif;`;
export const SECONDARY_FONT = `'Tinos', serif;`;
export const FANTASY = PRIMARY_FONT;
export const CURSIVE = PRIMARY_FONT;
